import { Controller } from "@hotwired/stimulus";

/**
 * チェックボックス一括選択用
 * @example
 * <input type="checkbox" ... data-controller="check_box" data-action="change->check_box#checkAll" data-target-name="event_group[event_ids][]" />
 */
export class CheckBoxController extends Controller {
  checkAll(event) {
    const targetName = event.currentTarget.dataset.targetName;
    const checkboxes = document.querySelectorAll(`input[name="${targetName}"]`);

    checkboxes.forEach((checkbox) => {
      checkbox.checked = event.currentTarget.checked;
    });
  }

  checkAllExceptCheckedEvents(event) {
    const targetName = event.currentTarget.dataset.targetName;
    const checkboxes = document.querySelectorAll(`input[name="${targetName}"]`);

    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = event.currentTarget.checked;
      }
    });
  }
}
